import { Footer } from "@components/footer/footer";
import { Header } from "@components/header/header";

interface Props {
  children: React.ReactNode;
}

export default function Layout({ children }: Props) {
  return (
    <>
      <Header />
      <div className="pt-[76px] md:pt-[92px] lg:pt-[108px]">{children}</div>
      <Footer />
    </>
  );
}
